import { tv } from 'tailwind-variants';

const PORTAL_SEARCH_INPUT_VARIANT = tv({
  slots: {
    inputClass: 'gbmask max-w-159 h-14  rounded-lg focus-within:border-primary-blue-grey px-5',
    suffixWrapperClass: 'flex gap-2 items-center',
    clearIconClass: 'w-6 h-6',
    dividerClass: 'h-10 bg-secondary-grey-steel m-0',
    searchIconClass: 'w-6 h-6',
  },
  variants: {},
});

export { PORTAL_SEARCH_INPUT_VARIANT };
